import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDate = (date: Date | string | undefined): string => {
  if (!date) return ''
  return dayjs.utc(date).format('DD-MM-YYYY')
}

export const formatDateTime = (dateTime: Date | string | undefined): string => {
  if (!dateTime) return ''
  return dayjs.utc(dateTime).local().format('DD-MM-YYYY [at] HH:mm')
}
